import { ErrorBoundary } from '@packages/shared';
import PageRenderer from './PageRenderer';
import { useFooterData } from './useFooterData';

export type FooterProps = {
  /** sets the type (entire footer, socket only) of how the footer should be rendered */
  type?: string;
};

export enum TestIds {
  main = 'module-footer',
  noData = 'module-footer-no-data',
  failedToLoad = 'module-footer-failed-to-load',
}

/**
 * Footer component description displayed in storybook
 * */
export const Footer = ({ type = 'full' }: FooterProps): JSX.Element | null => {
  const data = useFooterData();

  return data ? (
    <ErrorBoundary fallback={<div data-testid={TestIds.failedToLoad}>failed to load</div>}>
      <PageRenderer
        data-testid={TestIds.main}
        key="page-renderer-footer-module"
        data={data}
        socketOnly={type === 'socket'}
      />
    </ErrorBoundary>
  ) : null;
};
